import { ServiceCode, ArtifactType } from '@/shared/types';

import { ArtifactTypeNameMapping } from '../lib';

import { ActionButton, ActionButtonProps } from './ActionButton';

type ExtendedProps = Omit<ActionButtonProps, 'children'> & {
  type: ArtifactType;
  serviceCode: Nullable<ServiceCode>;
};

export const DownloadButton: React.FC<ExtendedProps> = ({ type, serviceCode, iconName, ...props }) => (
  <ActionButton {...props} iconName={iconName}>
    {ArtifactTypeNameMapping[`${type}.${serviceCode}` as keyof typeof ArtifactTypeNameMapping] ??
      ArtifactTypeNameMapping[type]}
  </ActionButton>
);
